import { render } from "./ContribuicaoCharters.vue?vue&type=template&id=2ec6d228&scoped=true"
import script from "./ContribuicaoCharters.vue?vue&type=script&lang=js"
export * from "./ContribuicaoCharters.vue?vue&type=script&lang=js"

import "./ContribuicaoCharters.vue?vue&type=style&index=0&id=2ec6d228&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ec6d228"]])

export default __exports__